import { render, staticRenderFns } from "./Inscricao.vue?vue&type=template&id=f0cfc6dc"
import script from "./Inscricao.vue?vue&type=script&lang=js"
export * from "./Inscricao.vue?vue&type=script&lang=js"
import style0 from "./Inscricao.vue?vue&type=style&index=0&id=f0cfc6dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports